// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3sq70","title":"Info_title__1jaP1","selects":"Info_selects__1Bapj","requiredAsterisk":"Info_requiredAsterisk__kvpUm"};